import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-confirmation-box',
  templateUrl: './confirmation-box.component.html',
  styleUrls: ['./confirmation-box.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class ConfirmationBoxComponent implements OnInit {
  @Input('title') title!: string;
  @Input('message') message!: string;
  @Input('subtitle') subtitle!: string;

  constructor(public modalCtrl: ModalController) {}

  ngOnInit(): void {}

  async dismiss(data: any) {
    this.modalCtrl.dismiss(data);
  }
}
